import $ from 'jquery';
import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

const requireComponent = require.context(
    // The relative path of the components folder
    './components',
    // Whether or not to look in subfolders
    true,
    // The regular expression used to match base component filenames
    /Base[A-Z]\w+\.(vue|js)$/,
);

requireComponent.keys().forEach((fileName) => {
    // Get component config
    const componentConfig = requireComponent(fileName);

    // Get PascalCase name of component
    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, ''),
        ),
    );

    // Register component globally
    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig,
    );
});

let imgUrl = document.head.querySelector('meta[name="imageUrl"]').content;
window.imgUrl = imgUrl;
Vue.prototype.imgUrl = window.imgUrl;

/** Image lazy loading */
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
});

/** Filters */
import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter,{
    symbol : '£',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
});

/** Validation */
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

/** Components */
import InstagramCarousel from '@/components/carousels/Instagram';
import GalleryCarousel from '@/components/carousels/Gallery';
import SpeechCarousel from '@/components/carousels/SpeechCarousel';
import EventCardHeaderItem from '@/components/cards/EventCardHeaderItem';
import EventCard from '@/components/cards/EventCard';
import ArchiveFilter from '@/components/filters/ArchiveFilter';
import AppealDonationGraph from "./components/graphs/AppealDonation";
import DonationAmounts from "./components/donations/DonationAmounts";
import NewsletterForm from "./components/forms/NewsletterForm";
import MsAnimatedNumber from "./components/partials/MsAnimatedNumber";
import ImageCtaList from "./components/sections/ImageCtaList";
import GocardlessRedirectFlowConfirmation from "./components/sections/GocardlessRedirectFlowConfirmation";
import DonationThankYou from "./components/donations/DonationThankYou";

/** Mixins */
import NavigationControl from '@/mixins/navigation-control';
import StylesControl from '@/mixins/styles-control';

/** Store */
import store from '@/store/index';

new Vue({
    el: '#app',
    store,
    mixins: [NavigationControl,StylesControl],
    components: {
        InstagramCarousel,GalleryCarousel,SpeechCarousel,
        EventCardHeaderItem,EventCard,
        ArchiveFilter,AppealDonationGraph,DonationAmounts,
        NewsletterForm,
        MsAnimatedNumber,
        ImageCtaList,
        GocardlessRedirectFlowConfirmation,
        DonationThankYou,

    },

    data() {
        return {
            mobileBp: 475,
        }
    },

    computed: {
        resetLink() {
            return window.location.href.split('?')[0];
        }
    },

    watch: {
        windowWidth(val) {
            /* Auto close responsive nav if open and window is larger than required */
            if (val > 1316) {
                this.navOpen = false;
            }
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });

            if (this.windowWidth <= this.mobileBp) {
                this.responsiveSpacers();
            }

        });
    },

    methods: {
        paginate(postType,page) {
            return this.$store.dispatch(
                'Forms/updateFormValue',
                {postType, key: 'paged', value: page}
            );
        },
        scrollToError() {
            setTimeout(function(){
                let first_error = $('.error').first();
                $("html, body").animate({ scrollTop: first_error.offset().top - 200}, 300);
                first_error.focus();
            }, 100);
        }
    }
});

/* Disable VUE devtools on production */
if (process.env.MIX_APP_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}



import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css'
import 'swiper/modules/autoplay/autoplay.min.css'

const swiper = new Swiper('.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoHeight: true,
    autoplay: {
        delay: 5000
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})


//LightGallery
 import 'lightgallery/dist/js/lightgallery-all.min';
$(document).ready(function() {

    $('#lightgallery').lightGallery({
        'download' : false
    });
    $(".lightgallery").each(function() {
      $(this).lightGallery({
          'download' : false
      });
    })

});

// Speech bubble open and close animation
$(document).ready(function() {
    $('.bubble_dropdown_handle').click(function(e) {
        e.preventDefault();
        var dropdown_id = $(this).data('dropdown-id');
        if ($('#bubble_dropdown_' + dropdown_id).is(':visible')) {
            $('#bubble_dropdown_' + dropdown_id).slideUp(200);
            $('#bubble_dropdown_handle_' + $(this).data('dropdown-id')).removeClass('bubble_open');
        } else {
            $('#bubble_dropdown_' + dropdown_id).slideDown(200);
            $(this).addClass('bubble_open');
            // Close all other dropdowns that isn't this one
            $('.bubble_dropdown').each(function() {
                if ($(this).attr('id') !== 'bubble_dropdown_' + dropdown_id) {
                    $('#bubble_dropdown_handle_' + $(this).data('dropdown-id')).removeClass('bubble_open');
                    $(this).slideUp(200);
                }
            });
        }
    });
});

$(document).click(function(event) {
    var $target = $(event.target);
    if(!$target.closest('.bubble_dropdown_handle').length && !$target.closest('.bubble_dropdown').length) {
        $('.bubble_dropdown').slideUp(200);
        $('.bubble_dropdown_handle').removeClass('bubble_open');
    }
});



export default null;
